module.exports = __webpack_public_path__ + "img/prevPage.de0f6208.svg";